/** Defaults match protoo-client WebSocketTransport retry policy. */
export const RECONNECT_MAX_RETRIES = 10;
export const RECONNECT_MIN_TIMEOUT_MS = 1000;
export const RECONNECT_MAX_TIMEOUT_MS = 8000;
export const RECONNECT_FACTOR = 2;

export interface ReconnectDelayOptions {
  minTimeoutMs?: number;
  maxTimeoutMs?: number;
  factor?: number;
}

/** Exponential backoff delay before retry attempt `attempt` (0-based after a failure). */
export function reconnectDelayMs(
  attempt: number,
  {
    minTimeoutMs = RECONNECT_MIN_TIMEOUT_MS,
    maxTimeoutMs = RECONNECT_MAX_TIMEOUT_MS,
    factor = RECONNECT_FACTOR,
  }: ReconnectDelayOptions = {}
): number {
  const n = Math.max(0, Number(attempt) || 0);
  return Math.min(maxTimeoutMs, minTimeoutMs * factor ** n);
}
